import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Steps, Typography } from "antd";
import { steps } from "../../../services/steps";
import "./newtest.css";
import BasicTestForm from "./basicForm";
import SelectQuestion from "./selectQuestion";
import FinalQuestionView from "./questionview";
import { fetchSubjectTableData } from "../../../features/adminAsync";

const { Step } = Steps;
const { Title } = Typography;

const NewTest = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector((state) => state.test.currentStep);

  useEffect(() => {
    dispatch(fetchSubjectTableData());
  }, [dispatch]);

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <SelectQuestion />;
      case 2:
        return <FinalQuestionView />;
      default:
        return <BasicTestForm />;
    }
  };

  return (
    <div className="new-test-wrapper">
      <div className="title-container" style={{ textAlign: "center" }}>
        <Title level={3}>Create New Test</Title>
      </div>

      <Steps current={currentStep} className="newtest-steps-holder">
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>

      <div className="new-test-form-holder">{renderStepContent()}</div>
    </div>
  );
};

export default NewTest;
